import { cx } from "@emotion/css";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "src/components/Default/LekUI/Button";

interface FolderEmptyItemProps {
	onClick: () => void;
	text?: string;
	className?: string;
}

export const FolderEmptyItem = ({
	onClick,
	text,
	className,
}: FolderEmptyItemProps) => {
	const { t } = useTranslation();

	return (
		<div
			className={cx(
				"folder-empty-item flex justify-center items-center w-100 border-radius-24",
				className,
			)}
		>
			<PrimaryButton onClick={onClick} className="flex items-center">
				<AddIcon className="mr-8 icon-normal" />
				{text || t("folder.addNext", "Dodaj kolejny")}
			</PrimaryButton>
		</div>
	);
};
